import React from 'react'
import { isMobile } from 'react-device-detect'

import ProfileSection from 'app/common/pixel-menu/_comp/ProfileSection'
import {
  DcBreadcrumbs,
  DcButton,
  DcFlexBox,
  DcOverlaySlider,
  PixelImage,
  PixelPageContainer,
  PixelTable,
  Section,
  SectionContent,
} from 'pixel-base'
import { get } from 'utils/api-routes.util'
import CheckIcon from 'utils/icons/check-icon'
import GearIcon from 'utils/icons/gear-icon'
import PlusIcon from 'utils/icons/plus-icon'
import XmarkIcon from 'utils/icons/xmark-icon'

import AddCourier from './AddCourier'
import CourierDetails from './CourierDetails'
import CourierSettings from './CourierSettings'

const breadcrumbs = [
  {
    name: 'Settings',
    active: false,
  },
  {
    name: 'Couriers',
    active: true,
  },
]

const Couriers = () => {
  const [couriers, setCouriers] = React.useState([])
  const [tableLoading, setTableLoading] = React.useState(true)
  const [showDetailModal, setShowDetailModal] = React.useState(false)
  const [courierId, setCourierId] = React.useState('new')
  const [addNewCourier, setAddNewCourier] = React.useState(false)

  const getCouriers = () => {
    setTableLoading(true)
    get('/settings/couriers').subscribe((res: any) => {
      setCouriers(res.response.data)
      setTableLoading(false)
    })
  }

  React.useEffect(() => {
    getCouriers()
  }, [])

  const readApi = () => {
    getCouriers()
  }
  const onRowClicked = (row) => {
    setCourierId(row.courier_id)
    setAddNewCourier(false)
    setShowDetailModal(true)
  }

  const columns = [
    {
      dataField: 'courier_logo',
      name: 'Courier',
      sortable: true,
      selector: (row) => (
        <PixelImage
          width="30px"
          borderRadius="30px"
          src={row.courier_company.image_path}
          alt=""
        />
      ),
    },
    {
      dataField: 'courier_name',
      name: 'Name',
      selector: (row) => row.courier_name,
      sortable: true,
    },
    {
      dataField: 'courier_type',
      name: 'Type',
      sortable: true,
      selector: (row) => row.courier_type.courier_type,
    },
    {
      dataKey: 'active',
      name: 'Is Active ?',
      sortable: true,
      selector: (row) =>
        row.is_active ? (
          <CheckIcon color="green" size={16} />
        ) : (
          <XmarkIcon color="red" size={16} />
        ),
    },
  ]

  return (
    <>
      <DcFlexBox
        height="60px"
        fontSize="16px"
        style={{
          fontSize: '16px',
          padding: '8px 0px',
          borderBottom: '1px solid #e5e5e5',
        }}
      >
        <DcFlexBox
          justifyContent="space-between"
          alignItems="center"
          padding=".5rem 20px"
        >
          <DcBreadcrumbs fontSize="16px" data={breadcrumbs} />

          <ProfileSection />
        </DcFlexBox>
      </DcFlexBox>

      <PixelPageContainer style={{ padding: '0 ' }}>
        <Section style={{ padding: '0px' }}>
          <SectionContent style={{ padding: '0px', borderRadius: '0px' }}>
            <DcFlexBox
              justifyContent="flex-end"
              alignItems="center"
              gap="5px"
              padding=" 5px 20px"
              height="auto"
            >
              <DcButton
                onClick={() => {
                  setCourierId('settings')
                  setShowDetailModal(true)
                }}
                size="sm"
                variant="secondary"
                withIcon={true}
              >
                <GearIcon size={16} /> Settings
              </DcButton>

              <DcButton
                onClick={() => {
                  setCourierId('new')
                  setShowDetailModal(true)
                }}
                size="sm"
                withIcon={true}
                variant="outline-success"
              >
                <PlusIcon size={16} /> <span>Add {!isMobile && 'Courier'}</span>
              </DcButton>
            </DcFlexBox>
          </SectionContent>
        </Section>
        <Section style={{ padding: '20px' }} isMobile={isMobile}>
          <SectionContent>
            <PixelTable
              columns={columns}
              data={couriers}
              progressPending={tableLoading}
              highlightOnHover={true}
              pointerOnHover={true}
              onRowClicked={onRowClicked}
            />
          </SectionContent>
        </Section>
      </PixelPageContainer>

      <DcOverlaySlider
        isOpen={showDetailModal}
        onClose={() => setShowDetailModal(false)}
        title={courierId === 'new' ? 'Add New Courier' : 'Courier Details'}
        padding="0px"
      >
        {courierId === 'new' ? (
          <AddCourier
            readApi={readApi}
            setCourierId={setCourierId}
            courierId={courierId}
          />
        ) : courierId === 'settings' ? (
          <CourierSettings />
        ) : (
          <CourierDetails
            readApi={readApi}
            addNewCourier={addNewCourier}
            setCourierId={setCourierId}
            courierId={courierId}
            setShowDetailModal={setShowDetailModal}
          />
        )}
      </DcOverlaySlider>
    </>
  )
}

export default Couriers
